export const GT_REGEXP = new RegExp(/_(Exo\d*\+)?GT\d*\..*$/);
